import PropTypes from 'prop-types';

import type { ColorKey } from 'components/utils/styles/types';

import * as styled from './styles/card';

type CardProps = {
  headerColor?: ColorKey;
  title: string | React.ReactNode | null;
  children: React.ReactNode[] | React.ReactNode;
  isSimple?: boolean;
};

export const Card = function Card({
  title,
  children,
  headerColor,
  ...props
}: CardProps) {
  return (
    <styled.Card {...props}>
      {title && (
        <styled.Header headerColor={headerColor}>{title}</styled.Header>
      )}
      {children}
    </styled.Card>
  );
};

Card.propTypes = {
  headerColor: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isSimple: PropTypes.bool,
};

Card.defaultProps = {
  title: null,
};
